import Configuration from '@/agilis/util/Configuration'
import dialogFormMixin from '@/agilis/components/DialogForm/dialogFormMixin'
import L from 'lodash'
import { mapGetters } from 'vuex'
import FormSelectPriceItem from '@/applications/sales/components/WorkPackageV3/FormSelectPriceItem/FormSelectPriceItem.vue'

export default {
  name: 'formDataTable',
  mixins: [dialogFormMixin],

  props: {
    fieldConfig: Object,
    value: Array,
    disabled: Boolean,
    jsonLogicContext: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    formCustomComponents: {
      FormSelectPriceItem
    },
    items: [],
    page: 1,
    itemsPerPage: 10
  }),

  created () {
    this.items = this.value
    if (this.fieldConfig.api) {
      this.fetchData()
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId'
    }),

    tableTitle () {
      return this.fieldConfig.label
    },

    headers () {
      const columns = this.fieldConfig.columns
      const hh = Object.values(columns).map((c) => {
        return {
          text: c.label,
          value: c.id
        }
      })

      return [
        ...hh,
        this.disabled ? null : { value: 'actions', text: 'Actions' }
      ].filter(Boolean)
    },

    defaultItem () {
      const columns = this.fieldConfig.columns
      const dd = Object.values(columns).reduce((acc, c) => {
        acc[c.id] = c.defaultValue !== undefined ? c.defaultValue : null
        return acc
      }, {})
      return dd
    },

    pageOffset () {
      return (this.page - 1) * this.itemsPerPage
    }
  },

  methods: {
    async fetchData () {
      const {
        url,
        body = {},
        method = 'GET',
        path = null,
        context = {}
      } = this.fieldConfig.api || { url: this.fieldConfig.url }

      if (!url) {
        console.debug(`FormSelect: invalid API setup for field "${this.fieldConfig.id}"`)
        return
      }

      try {
        const config = this.$axios.agilisRequestConfig(url, null, context)

        const response = await this.$axios({
          ...config,
          method: method.toLowerCase(),
          url,
          data: body
        })

        this.items = path ? L.get(response, path, []) : response.data
        this.decorateItems(this.items)
      } catch (error) {
        this.notifyError(error)
      }
    },

    renderColumn (colId, item) {
      const colConfig = this.fieldConfig.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    },

    async addItem () {
      try {
        const model = JSON.parse(JSON.stringify(this.defaultItem))
        const { columns, formRows } = this.fieldConfig
        const newItem = await this.openFormDialog(model, columns, formRows)

        this.items.push(newItem)
        this.decorateItems(this.items)
      } catch (e) {
        // ...
      }
    },

    async editItem (itemIndex) {
      try {
        const model = JSON.parse(JSON.stringify(this.value[itemIndex]))
        const { columns, formRows } = this.fieldConfig
        const updatedItem = await this.openFormDialog(model, columns, formRows)

        this.items.splice(itemIndex, 1, updatedItem)
        this.decorateItems(this.items)
      } catch (e) {
        // ...
      }
    },

    deleteItem (itemIndex) {
      this.items.splice(itemIndex, 1)
    },

    rowClasses (item) {
      if (item.__backgroundColor) {
        // For color classes, see https://vuetifyjs.com/en/styles/colors/#material-colors
        return item.__backgroundColor
      }
      return ''
    },

    decorateItems (items, themeIsDark = false) {
      return Configuration.datatable.decorateItems(this.fieldConfig, items, themeIsDark)
    }
  }
}
